import { capitalize } from '@applift/factor'
import clsx from 'clsx'
import { useGridRootProps } from '../../hooks/utils/useGridRootProps'
import { ReactTableColumn } from '../../models/gridReactTable'
import { flexRender } from '../../hooks/core/useReactTable'
import styles from '../../style'

export interface GridFooterCellProps extends ReactTableColumn {
  height: number | 'auto'
  showRightBorder?: boolean
  colIndex: number
}

export function GridFooterCell(props: GridFooterCellProps) {
  const {
    height,
    colIndex,
    showRightBorder,
    getSize,
    columnDef,
    id,
    accessorFn,
    ...other
  } = props
  const rootProps = useGridRootProps()
  const footerRowData = rootProps?.footerData ?? {}

  const width = getSize()
  const align = columnDef.meta?.align
  const field = id

  const style = {
    minWidth: width,
    maxWidth: width,
    minHeight: height,
    maxHeight: height === 'auto' ? 'none' : height, // max-height doesn't support "auto"
  }

  const shouldRender = props.id !== '__check__'

  const cellType = columnDef.footer || columnDef.cell
  // @ts-ignore
  const cellData = flexRender(cellType, {
    column: { ...other, accessorFn, id, getSize, columnDef },
    // @ts-ignore
    getValue: () => accessorFn?.(footerRowData, 0),
    // @ts-ignore
    renderValue: () => accessorFn?.(footerRowData, 0),
    row: { original: footerRowData },
    onAction: rootProps.onAction,
  })

  return (
    <div
      style={style}
      className={clsx(
        styles.cell,
        styles.cellColumnHeader,
        rootProps.classes?.cell,
        rootProps.classes?.cellColumnHeader,
        showRightBorder && [styles.withBorder, rootProps.classes?.withBorder],
        [
          // @ts-ignore
          styles[`cell--text${capitalize(align)}`],
          // @ts-ignore
          rootProps.classes?.[`cell--text${capitalize(align)}`],
        ]
      )}
      role="cell"
      data-field={field}
      data-colindex={colIndex}
    >
      {shouldRender ? cellData : null}
    </div>
  )
}
